import React from "react";
import "../../styles/PastEvent.scss";
import pe1 from "../../components/assets/pe-1.jpg";

const PastEvent: React.FC = () => {
  return (
    <section id="past-event" className="past-event-section" style={{ backgroundImage: `url(${pe1})` }}>
      <div className="overlay"></div>

      <div className="pe-content">
        <h1 className="pe-title">APLIC 2025 | Bangkok, Thailand</h1>

        <div className="pe-text-wrapper">
          <p className="pe-text">
            The Thailand Convention and Exhibition Bureau (TCEB) proudly supported the
            Asia Pacific Life Insurance Congress (APLIC 2025), a premier life insurance
            conference organized by the Thai Association of Insurance and Financial Advisor (THAIFA)
            in Thailand.
          </p>

          <p className="pe-text">
            The event attracted an impressive turnout of over 4,200 participants from various
            countries, significantly contributing to the Thai economy with an estimated income
            stimulus of more than 280 million baht.
          </p>
        </div>
      </div>
       <p className="pe-credit">© 2025 Thailand Convention and Exhibition Bureau (Public Organization)</p>
    </section>
  );
};

export default PastEvent;
